var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollRef"},[_c('div',{staticClass:"card-header shadow",attrs:{"gutter":1}},[_vm._m(0)]),_c('div',{staticClass:"card-body"},[_c('ConferenceMainView')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-left"},[_c('h1',{staticClass:"header-title",staticStyle:{"float":"left"}},[_c('i',{staticClass:"icon-al-chazhao",staticStyle:{"font-size":"24px"}}),_vm._v(" Chat Room ")])])
}]

export { render, staticRenderFns }